import React, { memo, useCallback, useEffect, useState } from 'react'
import { Button, ScrollArea } from '@mantine/core'
import { IconPlus } from '@tabler/icons'
import { Toast } from '@ow/comps'
import { css } from '@emotion/css'
import { pick } from 'lodash-es'
import tw from 'twin.macro'
import { getQuery } from '@vt/utils'
// import { useNavigate } from 'react-router-dom'
import { transformTplFromAppId } from '@vt/apis/lib-ex'
import { getInformationStorage } from '@vt/apis/lib-ex/v2/login'
import useAppListStore from './appListStore'
import Search from './search'
import Section from './section'
import CreateModal from './createModal'
import ContentEditModal from './contentEditModal'

const CONTENT_ID = 'app-list-content'

const Content = () => {
  const [createOpened, setCreatOpened] = useState(false)

  // const navigate = useNavigate()
  const { token } = getQuery()
  const { getList, setState, sections } = useAppListStore((state) =>
    pick(state, ['getList', 'setState', 'sections'])
  )

  const onCloseCreateModal = useCallback(() => {
    setCreatOpened(false)
  }, [])

  const onSearch = useCallback(
    (filter) => {
      setState({ filter })
      getList()
    },
    [getList, setState]
  )

  useEffect(() => {
    getList()
  }, [getList])

  // 类似/apps/$appId/res/95?token=$token'形式的路径参数值替换
  const transUrl = ({ url, tpl, appId }) => {
    const targetUrl = url.url
    const mergedProps = {
      token,
      key: tpl,
      appId,
    }
    if (!url) return null

    let finalUrl = targetUrl

    console.log('props', finalUrl)
    const vars = finalUrl.match(/\$[a-zA-Z]+/g) || []

    vars.forEach((v) => {
      const key = v.replace('$', '')
      finalUrl = finalUrl.replace(v, mergedProps[key])
    })

    // if (appId) {
    //   finalUrl = url.replace('$appId', appId)
    // }

    // finalUrl = finalUrl.replace('$token', token)
    // finalUrl = finalUrl.replace('$key', RAP)
    // finalUrl = finalUrl.replace('$cpkey', `/cp/${RAP}`)
    return finalUrl
  }

  const itemClickHandler = (item) => {
    console.log('item', item)
    const tpl = transformTplFromAppId[item.id]
    return getInformationStorage(item.id, tpl)
      .then((result) => {
        const redirectUrl = result.value.url || {}
        const url = transUrl({ url: redirectUrl, ...result })
        console.log('redirectUrl', url)
        // 跨项目跳转，需要reload
        window.location.href = url
      })
      .catch((err) => {
        Toast.error({
          title: '提示',
          description: err.message,
        })
      })
  }

  return (
    <div id={CONTENT_ID} className="flex-1">
      <ScrollArea className="h-full">
        <div
          className={css`
            box-shadow: 0 0 8px 0 #e2e7e7;
            ${tw`bg-white rounded-lg m-5`}
          `}
        >
          <div className="h-14 flex justify-between items-center border-b px-6">
            <h2>应用列表</h2>
            <Search onSearch={onSearch} />
          </div>
          <div className="py-2">
            <div className="px-6 py-4">
              <Button
                className={css`
                  background: var(--ow-color-primary-700);
                  &:hover {
                    background: var(--ow-color-primary-800);
                  }
                  padding-left: 14px;
                  padding-right: 14px;
                  height: 32px;
                `}
                type="primary"
                leftIcon={<IconPlus />}
                onClick={() => setCreatOpened(true)}
              >
                新建项目
              </Button>
            </div>
            <Section
              title="星标项目"
              appList={sections.star}
              itemClickHandler={itemClickHandler}
            />
            <Section
              title="我创建的"
              appList={sections.created}
              itemClickHandler={itemClickHandler}
            />
            <Section
              title="回收站"
              appList={sections.deleted}
              defaultClose
              itemClickHandler={itemClickHandler}
            />
            <Section
              title="已归档"
              itemClickHandler={itemClickHandler}
              appList={sections.joined}
              underLine={false}
            />
          </div>
        </div>
      </ScrollArea>
      <CreateModal
        target={'#' + CONTENT_ID}
        opened={createOpened}
        onClose={onCloseCreateModal}
      />
      <ContentEditModal target={'#' + CONTENT_ID} />
    </div>
  )
}

export default memo(Content)
